import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TreeItem, TreeItemButton } from "@air/component-tree";
import { Check } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { Tooltip } from "@air/primitive-tooltip";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import { useLibraryRootBoards } from "~/components/LibraryBeta/hooks/queries/useLibraryRootBoards";
import { useFetchObjectsPermissions } from "~/hooks/useFetchObjectsPermissions";
import { useCurrentWorkspace } from "~/providers/CurrentWorkspaceProvider";
import { BoardSearchListItem } from "./BoardSearchListItem";
export const LibraryListItem = /*#__PURE__*/ memo((param)=>{
    let { getIsLibraryDisabled, getIsBoardDisabled, initialBoardId, isBoardSelected, isLibrarySelected, library, libraryBoards, onBoardSelectChange: onBoardClick, onSelectLibrary, shouldExpandLibraryInsteadOfSelect, shouldShowLibraryBoards, shouldShowSubBoards } = param;
    const containerRef = useRef(null);
    const [isExpanded, setIsExpanded] = useState(false);
    const { currentWorkspace } = useCurrentWorkspace();
    const toggleExpanded = useCallback(()=>{
        setIsExpanded((prevState)=>!prevState);
    }, [
        setIsExpanded
    ]);
    const isSelected = !!(isLibrarySelected === null || isLibrarySelected === void 0 ? void 0 : isLibrarySelected(library));
    const isDisabled = getIsLibraryDisabled === null || getIsLibraryDisabled === void 0 ? void 0 : getIsLibraryDisabled(library);
    const onClickTitle = useCallback(()=>{
        if (shouldExpandLibraryInsteadOfSelect) {
            toggleExpanded();
        } else {
            onSelectLibrary === null || onSelectLibrary === void 0 ? void 0 : onSelectLibrary(library);
        }
    }, [
        onSelectLibrary,
        library,
        shouldExpandLibraryInsteadOfSelect,
        toggleExpanded
    ]);
    useEffect(()=>{
        if (shouldShowLibraryBoards === null || shouldShowLibraryBoards === void 0 ? void 0 : shouldShowLibraryBoards(library.id)) {
            setIsExpanded(true);
        }
    }, [
        shouldShowLibraryBoards,
        library.id
    ]);
    useEffect(()=>{
        if (isSelected && containerRef.current) {
            containerRef.current.scrollIntoView();
        }
    }, [
        isSelected,
        library
    ]);
    // this will be replaced with a proper api call when we have the endpoint
    const { data: boards = [], isLoadingMore, hasMore, loadNextPage } = useLibraryRootBoards(isExpanded && !libraryBoards ? currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.id : undefined, library.id);
    useFetchObjectsPermissions({
        objects: {
            boardIds: boards.map((board)=>board.id)
        }
    });
    const treeElement = /*#__PURE__*/ _jsx(TreeItemButton, {
        className: !!isDisabled ? "pointer-events-none opacity-60" : "",
        onClick: onClickTitle,
        children: library.title
    });
    return /*#__PURE__*/ _jsxs("div", {
        ref: containerRef,
        children: [
            /*#__PURE__*/ _jsx(TreeItem, {
                "data-title": library.title,
                className: isSelected ? "bg-indigo-1" : "hover:bg-grey-4",
                suffix: isSelected && /*#__PURE__*/ _jsx(Check, {
                    className: "flex size-4 shrink-0 items-center text-blue-11"
                }),
                open: isExpanded,
                onOpenChange: toggleExpanded,
                children: !!isDisabled ? /*#__PURE__*/ _jsx(Tooltip, {
                    label: isDisabled.message,
                    side: "left",
                    sideOffset: 0,
                    children: /*#__PURE__*/ _jsx("div", {
                        children: treeElement
                    })
                }) : treeElement
            }),
            isExpanded && /*#__PURE__*/ _jsxs("div", {
                className: "ml-4",
                children: [
                    (libraryBoards || boards).map((board)=>{
                        return /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(BoardSearchListItem, {
                                shouldShowSubBoards: shouldShowSubBoards,
                                isBoardSelected: isBoardSelected,
                                onBoardSelectChange: onBoardClick,
                                board: board,
                                getIsBoardDisabled: getIsBoardDisabled,
                                initialBoardId: initialBoardId
                            })
                        }, board.id);
                    }),
                    !isLoadingMore && hasMore && /*#__PURE__*/ _jsx(Button, {
                        onClick: ()=>loadNextPage(),
                        className: "ml-4 px-4",
                        size: "small",
                        appearance: "ghost",
                        color: "grey",
                        children: "Show more"
                    })
                ]
            })
        ]
    });
});
LibraryListItem.displayName = "LibraryListItem";
